module.exports = __webpack_public_path__ + "static/img/pay-icon01.2300776d.svg";